module.exports = __webpack_public_path__ + "static/img/stick.e5f366f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stick.png
// module id = 5Zy4
// module chunks = 1